import DeleteButton from './DeleteButton';
import React from 'react';

import { MDBMedia, MDBIcon, MDBContainer } from 'mdbreact';

const Comment = props => {
  const comment = props.comment;
  const show = props.currentUser &&
    props.currentUser.username === comment.author.username;
  return (
    <MDBContainer>
      <MDBMedia className="d-block d-md-flex mt-4">
        <img className="card-img-64 d-flex mx-auto mb-3" src={comment.author.image} alt="" />
        <MDBMedia body className="text-center text-md-right mr-md-3 mr-0">
          <h5 className="font-weight-bold mt-0">
            {comment.author.username}<MDBIcon icon="reply" className="pull-right ml-2" />
          </h5>
          {comment.body}
        </MDBMedia>
        <div class="row" dir="ltr">
          <div class="col-md-12 col-xl-12 d-flex justify-content-left">
            <p class="font-small grey-text mb-0 ml-3">
              {new Date(comment.createdAt).toLocaleDateString('ar-EN',
                {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
            </p>
          </div>
          <div class="col-md-12 col-xl-12 d-flex justify-content-left">
            <DeleteButton show={show} slug={props.slug} commentId={comment.id} />
          </div>
        </div>
      </MDBMedia>
    </MDBContainer>
  );
};

export default Comment;
